import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { Row, Col, Container as BContainer } from 'reactstrap'
import { media } from 'ui/rwd'

const Heading = styled.h1`
  color: ${theme('black')};
  font-size: 36px;
  font-weight: bold;
`

const Content = styled(Row)`
  padding: 0;
  padding-top: 3rem;
  ${media.sm.down`
    ${props => (props.reverse ? 'flex-direction: column-reverse' : '')};
  `}
`

const Description = styled.p`
  text-align: justify;
`

const Image = styled.img`
  max-height: 376px;
  max-width: 100%;
  width: 100%;
  object-fit: contain;
  ${media.sm.down`
    max-height: 200px;
  `}
`

const ImageWrapper = styled(Col)`
  display: block;
`

const Container = styled(BContainer)`
  margin-bottom: 3rem;
`

export { Heading, Content, ImageWrapper, Description, Image, Container }
